import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';

export function DebugBlocked() {
  return (
    <div className="center flex-col gap-8 height-100">
      <p className="h5 mb-16">Blocked, cannot debug</p>

      <LinkButton variant="secondary" to="../enroll" relative="path">
        Unblock
      </LinkButton>
    </div>
  );
}
